<template>

  <div class="md-layout text-center login-fix-page">

    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix"
    >
        <h5>CASUAL LABOURER MANAGEMENT SYSYTEM (VIBARUA v1)</h5>



      <form @submit.prevent="login">
        <login-card header-color="blue">
          <h4 slot="title" class="title">Log in</h4>
          <md-field
            class="form-group md-invalid"
            slot="inputs"
            style="margin-bottom: 28px"
          >
            <md-icon>email</md-icon>
            <label>Email...</label>
            <md-input v-model="email" type="email" />
            <validation-error :errors="apiValidationErrors.email" />
          </md-field>
          <md-field class="form-group md-invalid" slot="inputs">
            <md-icon>lock_outline</md-icon>
            <label>Password...</label>
            <md-input v-model="password" type="password" />
          </md-field>
          <md-button class="md-simple md-success md-lg"   slot="footer">
            <router-link to="/reset">  Reset Password </router-link>

          </md-button>

          <md-button
            slot="footer"
            class="md-simple md-success md-lg"
            type="submit"
          >
            Login
          </md-button>
        </login-card>
      </form>
    </div>
  </div>
</template>

<script>
import { LoginCard, ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: {
        LoginCard,
        ValidationError,
    },
    mixins: [formMixin],
    computed: {
        isAuthenticated: function () {
            return this.$store.getters.isAuthenticated();
        },
    },
    data: () => ({
        email: '',
        password: '',
    }),
    methods: {
        async login () {
            const user = {
                data: {
                    type: 'token',
                    attributes: {
                        email: this.email,
                        password: this.password,
                    },
                },
            };

            const requestOptions = {
                headers: {
                    Accept: 'application/vnd.api+json',
                    'Content-Type': 'application/vnd.api+json',
                },
            };

            try {
                await this.$store.dispatch('auth/login', { user, requestOptions });
            } catch (e) {
                console.log(e);
                await this.notifyError('Invalid credentials!');
                this.setApiValidation(e.response.data.errors);
            }
        },
    },
};
</script>
<style scoped>
.login-fix-page {
  padding-bottom: 7em;
  padding-top: 4em;
}
</style>
